import { getProxyUrl } from '.'

export async function getElementosEnlazadosUnidadAcabados(
  linkedID: number,
  idElementosEnlazados: number,
) {
  const url = getProxyUrl(
    `api/Acabados/getelementosenlazadosunidadacabados/${linkedID}/${idElementosEnlazados}`,
  )

  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  })

  if (!response.ok) {
    const errorDetail = await response.json().catch(() => ({}))
    throw new Error(errorDetail?.detail || 'Error al obtener elementos enlazados')
  }

  return await response.json()
}
